import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import VueI18n from 'vue-i18n';
import VueAnalytics from 'vue-analytics';
import BootstrapVue from 'bootstrap-vue';
import 'vue-awesome/icons';
import Icons from 'vue-awesome/components/Icon';
import routes from './routes';
import { createStore } from './store';
import App from './App.vue';
import { sync } from 'vuex-router-sync';
import Multiselect from 'vue-multiselect';
import Paginate from 'vuejs-paginate';
import NProgress from 'nprogress';
import VueTheMask from 'vue-the-mask';
import Toasted from 'vue-toasted';

Vue.use(Toasted);

Vue.use(VueTheMask);

import money from 'v-money';

// register directive v-money and component <money>
Vue.use(money, { precision: 4 });
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(VueTheMask);

Vue.config.productionTip = 'production';

// Moment
Vue.use(require('vue-moment'));

//MultiSelect
Vue.component('multiselect', Multiselect);

// I18N
const defaultLocale = 'fr';
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
});

Vue.component('i18n', i18n);

// Icon FontAwesome
Vue.component('v-icon', Icons);

//Bootstrap
Vue.use(BootstrapVue);

//Vuex
Vue.use(Vuex);
const store = createStore();

//Routes
Vue.use(Router);
export const router = new Router({
    mode: 'hash',
    routes,
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start();
    }
    next();
});
router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done();
});

const unsync = sync(store, router);

// Paginate
Vue.component('paginate', Paginate);

//directive
Vue.directive('decimalSperator', {
    bind(el) {
        var inputHandler = function (e) {
            e.target.value = e.target.value.replace(',', '.');

        };
        el.addEventListener("change", inputHandler);
    },
});

Vue.prototype.$MAX_2000 = 2000;
Vue.prototype.$MAX_255 = 255;

// My Vue
new Vue({
    router,
    store,
    i18n,
    unsync,
    props: {
        dataJwt: null,
    },
    beforeMount: function () {
        const getAttribute = (attributeKey, defaultValue) => {
            if (
                !this.$el.attributes[attributeKey] ||
                !this.$el.attributes[attributeKey].value ||
                this.$el.attributes[attributeKey].value == 'false' ||
                this.$el.attributes[attributeKey].value == 0
            ) {
                return defaultValue;
            }

            return this.$el.attributes[attributeKey].value;
        };

        const parameters = {
            urlApiProperty: getAttribute('data-url-property', ''),
            codeAnalytics: getAttribute('data-code-analytics', 'UA-140848807-3'),
            jwt: getAttribute('data-jwt', null),
            component: getAttribute('data-component', null),
        };

        //Analytics
        Vue.use(VueAnalytics, {
            id: parameters.codeAnalytics,
            router,
        });

        store.dispatch('setParameters', parameters);

        router.push({ name: parameters.component });
    },
    render: h => h(App),
}).$mount('#gaia-branchement-app');

window.app = {
    router,
    i18n,
};
